module.exports = __webpack_public_path__ + "img/pratique-lazy.4039e40d.jpg";